import { DestroyRef, Directive, inject } from '@angular/core';
import { GridCell, GridCellWidget } from '@angular/aria/grid';

import { MibTableWidgetsService } from './table-widgets.service';

/**
 * Marks a control the page put inside a cell — a favourite, an actions trigger, a checkbox — as one
 * the table's arrow keys should reach.
 *
 * The table is one tab stop, so a control that says nothing about itself is walked past. This is the
 * one thing a page has to write when it puts something pressable in a cell, and it is here so that
 * a page never has to import `@angular/aria` to do it.
 *
 * ```html
 * <ng-template mibCell="actions" let-c>
 *   <button mibCellWidget mibButton mode="ghost" [mibMenuTrigger]="actions" aria-label="Options">
 *     <svg mib-icon name="ellipsis"></svg>
 *   </button>
 * </ng-template>
 * ```
 *
 * It also raises the control above the row link, so it answers itself and not the row, and keeps
 * its cell out of the disabled state of a disabled row.
 */
@Directive({
  selector: '[mibCellWidget]',
  hostDirectives: [GridCellWidget],
})
export class MibTableCellWidgetDirective {
  constructor() {
    const widgets = inject(MibTableWidgetsService, { optional: true });
    const cell = inject(GridCell, { optional: true });
    if (!widgets || !cell) return;
    widgets.add(cell);
    inject(DestroyRef).onDestroy(() => widgets.remove(cell));
  }
}
